module.exports = __webpack_public_path__ + "static/img/8.ec89a84.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/zh/8.png
// module id = Immd
// module chunks = 0